import React from 'react';
import { formatNumber } from '../../../utils';
import {
  TotalCard,
  TotalContent,
  TotalLabel,
  TotalValueContainer,
  TotalValue,
  TotalSymbol,
  TotalIcon,
} from './styles';
import { TotalProps } from './types';

export const Total: React.FC<TotalProps> = ({
  variant,
  label,
  value,
  icon,
  color,
  iconColor,
  currency = 'USD',
  className,
}) => {
  const formatValue = () => {
    if (variant === 'amount') {
      return {
        symbol: getCurrencySymbol(currency),
        value: formatNumber(value),
        symbolPosition: 'before' as const,
      };
    } else {
      return {
        symbol: '%',
        value: formatNumber(value),
        symbolPosition: 'after' as const,
      };
    }
  };

  const getCurrencySymbol = (curr: string): string => {
    const symbols: Record<string, string> = {
      USD: '$',
      EUR: '€',
      GBP: '£',
      INR: '₹',
      JPY: '¥',
      CNY: '¥',
      AUD: 'A$',
      CAD: 'C$',
    };
    return symbols[curr] || curr;
  };

  const { symbol, value: formattedValue, symbolPosition } = formatValue();

  return (
    <TotalCard className={className}>
      <TotalContent>
        <TotalLabel>{label}</TotalLabel>
        <TotalValueContainer>
          {symbolPosition === 'before' && (
            <TotalSymbol $variant={variant}>{symbol}</TotalSymbol>
          )}
          <TotalValue $variant={variant}>{formattedValue}</TotalValue>
          {symbolPosition === 'after' && (
            <TotalSymbol $variant={variant}>{symbol}</TotalSymbol>
          )}
        </TotalValueContainer>
      </TotalContent>
      {icon && <TotalIcon $color={color} $iconColor={iconColor}>{icon}</TotalIcon>}
    </TotalCard>
  );
};

export type { TotalProps, TotalVariant } from './types';
